import './ReactTabs.scss'
import {
  TabsV1IsEmptyFn,
  TabsV1Properties,
  TabsV1State,
  withAuthorPanelSwitch,
  withStandardBaseCssClass
} from '@adobe/aem-core-components-react-spa'
import { ComponentMapping, Container } from '@adobe/aem-react-editable-components'

import IsInEditorText from '../shared/IsInEditorText'

interface ReactTabsProps extends TabsV1Properties {
  id?: string
  lob?: string
  tag?: any
}
class ReactTabs extends Container<ReactTabsProps, TabsV1State> {
  constructor(props: ReactTabsProps) {
    super(props)

    this.state = {
      activeIndex: !!props.activeItem && props.activeItem.length > 0 ? this.props.cqItemsOrder.indexOf(props.activeItem) : 0,
      componentMapping: this.props.componentMapping || ComponentMapping
    }

    this.handleTabNavClick = this.handleTabNavClick.bind(this)
  }

  componentDidUpdate(prevProps: Readonly<TabsV1Properties>): void {
    if (
      this.props.activeIndexFromAuthorPanel !== undefined &&
      prevProps.activeIndexFromAuthorPanel != this.props.activeIndexFromAuthorPanel
    ) {
      this.setState({ activeIndex: this.props.activeIndexFromAuthorPanel })
    }
  }

  handleTabNavClick(index: number) {
    if (this.state.activeIndex !== index) {
      this.setState({
        activeIndex: index
      })
    }
  }

  tabNavigation() {
    const childComponents: JSX.Element[] = []
    const { isInEditor = false, lob = '', tag = 'h4' } = this.props
    const ElementTag = tag

    if (!this.props.cqItems || !this.props.cqItemsOrder) {
      return childComponents
    }

    return (
      <>
        {IsInEditorText(isInEditor, 'React Tabs')}
        <div className={`react-tabs-container container ${lob}`}>
          <ul role='tablist'>
            {this.props.cqItemsOrder.map((item, index) => {
              const tab = this.props.cqItems[item]
              return (
                <li
                  key={`${tab['cq:panelTitle']}-${index}`}
                  tabIndex={0}
                  role='tab'
                  aria-controls={`tabpanel-${index}`}
                  aria-selected={this.state.activeIndex === index}
                  onClick={() =>
                    this.setState({
                      activeIndex: index
                    })
                  }
                  onKeyDown={(e) =>
                    e.key === 'Enter'
                      ? this.setState({
                          activeIndex: index
                        })
                      : null
                  }
                >
                  <ElementTag className={`tab-title ${this.state.activeIndex === index ? 'active' : ''}`}>
                    {tab['cq:panelTitle']}
                  </ElementTag>
                  <div className={`${this.state.activeIndex === index ? 'active-tab-seperator' : 'no-show'}`}></div>
                </li>
              )
            })}
          </ul>
          <div className='tab-content'>
            {isInEditor === true ? (
              <>
                {this.childComponents.map((item, index) => {
                  const isVisible = this.state.activeIndex === index
                  const styles = { display: !isVisible ? 'none' : 'block' }

                  return (
                    <div
                      style={styles}
                      role='tabpanel'
                      id={`tabpanel-${index}`}
                      key={'tab-content-' + item.key}
                      aria-hidden={!isVisible}
                    >
                      {this.childComponents[index]}
                    </div>
                  )
                })}
              </>
            ) : (
              <>
                {this.childComponents.map((child, index) => {
                  const isVisible = this.state.activeIndex === index
                  const styles = { display: !isVisible ? 'none' : 'block' }

                  return (
                    <div style={styles} aria-hidden={!isVisible} id={`tabpanel-${index}`} role='tabpanel'>
                      {child}
                    </div>
                  )
                })}
              </>
            )}
          </div>
        </div>
      </>
    )
  }

  get tabContainerProps() {
    const attrs = this.containerProps
    attrs['className'] = attrs.className + ' ' + this.props.baseCssClass
    attrs['data-cmp-is'] = 'tabs'
    attrs['data-panelcontainer'] = 'tabs'
    attrs['data-testid'] = 'reacttabs-container'

    return attrs
  }

  render() {
    const isEmpty = TabsV1IsEmptyFn(this.props)
    const { id = '' } = this.props
    return (
      <div {...this.tabContainerProps} id={id}>
        {!isEmpty && this.tabNavigation()}
        {this.placeholderComponent}
      </div>
    )
  }
}

export default withStandardBaseCssClass(withAuthorPanelSwitch(ReactTabs), 'cmp-tabs')
